import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '.././plugins/i18n'
const base = 'bookings'

AdminRouter.addRoutes([
  {
    path: '/',
    redirect: {
      name: `${base}`,
    },
  },
  {
    name: `${base}`,
    path: `/${base}`,
    component: () => import('./Index.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.create`,
    path: `/${base}/create`,
    component: () => import('./Add.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.edit`,
    path: `/${base}/:id`,
    component: () => import('./Edit.vue'),
    meta: {
      auth: true,
    },
  },
])

AdminSidebar.pushItem({
  id: `${base}`,
  order: 10,
  header: $vm => $vm.$t(`general.menu_main`),
  text: $vm => $vm.$t('bookings.title'),
  route: {
    name: `${base}`,
  },
  icon: 'icon-stack',
  permission() {
    return true
  },
})

messageGroups.push(
  base,
  'airportslist',
  'enums',
  'orders',
  'reviews',
  'vehiclelist',
  'widget',
)
